
  import { Vue, Component, Prop } from "vue-property-decorator";

  import FormInputGroup from "@/components/form/FormInputGroupNew.vue";

  @Component({
    components: {
      FormInputGroup,
    },
  })
  export default class InputRangeFilter extends Vue {
    @Prop({ type: [String, Number], default: "" }) minValue!: string | number;
    @Prop({ type: [String, Number], default: "" }) maxValue!: string | number;
    @Prop({ type: String, default: undefined }) readonly inputClasses?: string;
    @Prop({ type: String, default: undefined }) readonly prefix?: string;
    @Prop({ type: String, default: undefined }) readonly inputClass?: string;
    @Prop({ type: String, default: "" }) readonly iconStyle!: string;
    @Prop({ type: String, default: undefined }) readonly suffix?: string;

    handleInput(name: string, value: string) {
      if (value == "0") {
        value = "";
      }
      if (parseInt(value) < 0) {
        value = "";
      }
      this.$emit(`update:${name}`, value);
    }
  }
